import { render, staticRenderFns } from "./nepaChildSupport.vue?vue&type=template&id=a088214e&scoped=true"
import script from "./nepaChildSupport.vue?vue&type=script&lang=js"
export * from "./nepaChildSupport.vue?vue&type=script&lang=js"
import style0 from "./nepaChildSupport.vue?vue&type=style&index=0&id=a088214e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a088214e",
  null
  
)

export default component.exports